import { useMemo } from 'react';
import { Link, useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollReveal from '@/components/base/ScrollReveal';
import ParticleBackground from '@/components/base/ParticleBackground';
import { caseItems } from '@/pages/case/data';

export default function CaseDetail() {
  const { slug } = useParams();

  const selectedCase = useMemo(() => caseItems.find((item) => item.slug === slug), [slug]);

  if (!selectedCase) {
    return (
      <div className="ui-page">
        <Navbar />
        <main className="pt-28 px-4 md:px-8 lg:px-12">
          <div className="max-w-screen-md mx-auto text-center py-20">
            <h1 className="font-heading text-3xl text-primary-500 mb-4">案例不存在</h1>
            <p className="text-secondary-400 mb-8">该案例可能已下线或链接有误。</p>
            <Link to="/case" className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-primary-500 text-background-950 text-sm font-medium">
              返回作品案例
            </Link>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="ui-page">
      <Navbar />
      <main className="pt-20">
        <section className="relative py-16 md:py-24 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-background-900/40 to-transparent z-[1]"></div>
          <ParticleBackground compact />
          <div className="w-full px-4 md:px-8 lg:px-12 relative z-10">
            <div className="max-w-screen-xl mx-auto">
              <ScrollReveal>
                <div className="mb-10">
                  <Link to="/case" className="inline-flex items-center gap-2 text-secondary-400 hover:text-primary-500 transition-colors mb-5">
                    <i className="ri-arrow-left-line"></i>
                    返回案例目录
                  </Link>
                  <h1 className="ui-title-glow font-heading text-3xl md:text-5xl font-bold text-primary-500 mb-4">{selectedCase.title}</h1>
                  <div className="flex items-center gap-3 mb-4">
                    <span className="px-3 py-1 rounded-full bg-accent-500/15 border border-accent-500/20 text-accent-300 text-xs font-medium whitespace-nowrap">{selectedCase.category}</span>
                    <span className="text-secondary-500 text-xs">{selectedCase.date}</span>
                  </div>
                  <p className="text-secondary-300 leading-relaxed max-w-3xl">{selectedCase.desc}</p>
                </div>
              </ScrollReveal>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                {selectedCase.media.map((media) => (
                  <ScrollReveal key={`${selectedCase.slug}-${media.title}`}>
                    <div className="ui-panel rounded-2xl overflow-hidden">
                      <div className="aspect-video bg-background-900">
                        {media.type === 'video' ? (
                          <video className="w-full h-full object-cover" controls preload="metadata" poster={media.poster}>
                            <source src={media.url} type="video/mp4" />
                            您的浏览器不支持视频播放。
                          </video>
                        ) : (
                          <img src={media.url} alt={media.title} className="w-full h-full object-cover" />
                        )}
                      </div>
                      <div className="px-4 py-3 border-t border-primary-500/10 text-sm text-secondary-300">{media.title}</div>
                    </div>
                  </ScrollReveal>
                ))}
              </div>

              <div className="py-4 px-5 bg-primary-500/5 rounded-xl border border-primary-500/15">
                <p className="text-primary-400 text-sm font-medium">{selectedCase.highlight}</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}



